/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";


export default function data({lines = [], editAction}) {

  const rows = lines.map((line) => {
    return {
      name: (
            <MDTypography display="block" style={{cursor: "pointer"}} variant="button" fontWeight="medium" onClick={() => editAction(line)}> 
                {line.name}
            </MDTypography>
        ), 
        studio: (
            <MDTypography display="block" style={{cursor: "pointer"}} variant="button" fontWeight="medium" onClick={() => editAction(line)}> 
                {line.studio.name}
            </MDTypography>
        ),
        action: (
          <MDTypography component="a" style={{cursor: "pointer"}} variant="caption" color="text" fontWeight="medium" onClick={() => editAction(line)}>
            Edit
          </MDTypography>
        ),
    };
  });

  return {
    columns: [
      { Header: "Name", accessor: "name", width: "45%", align: "left" },
      { Header: "Studio", accessor: "studio", width: "45%", align: "left" },
      { Header: "action", accessor: "action", align: "center" },
    ],

    rows: rows,
  };
}
